var map = {
	"./01d.svg": "./src/assets/icons/svg/01d.svg",
	"./01n.svg": "./src/assets/icons/svg/01n.svg",
	"./02d.svg": "./src/assets/icons/svg/02d.svg",
	"./02n.svg": "./src/assets/icons/svg/02n.svg",
	"./03d.svg": "./src/assets/icons/svg/03d.svg",
	"./03n.svg": "./src/assets/icons/svg/03n.svg",
	"./04d.svg": "./src/assets/icons/svg/04d.svg",
	"./04n.svg": "./src/assets/icons/svg/04n.svg",
	"./09d.svg": "./src/assets/icons/svg/09d.svg",
	"./09n.svg": "./src/assets/icons/svg/09n.svg",
	"./10d.svg": "./src/assets/icons/svg/10d.svg",
	"./10n.svg": "./src/assets/icons/svg/10n.svg",
	"./11d.svg": "./src/assets/icons/svg/11d.svg",
	"./11n.svg": "./src/assets/icons/svg/11n.svg",
	"./13d.svg": "./src/assets/icons/svg/13d.svg",
	"./13n.svg": "./src/assets/icons/svg/13n.svg",
	"./50d.svg": "./src/assets/icons/svg/50d.svg",
	"./50n.svg": "./src/assets/icons/svg/50n.svg",
	"./Alert.svg": "./src/assets/icons/svg/Alert.svg",
	"./Doc.svg": "./src/assets/icons/svg/Doc.svg",
	"./Done.svg": "./src/assets/icons/svg/Done.svg",
	"./Error_404.svg": "./src/assets/icons/svg/Error_404.svg",
	"./Error_Alert.svg": "./src/assets/icons/svg/Error_Alert.svg",
	"./Error_LocationOff.svg": "./src/assets/icons/svg/Error_LocationOff.svg",
	"./Error_Maintenance.svg": "./src/assets/icons/svg/Error_Maintenance.svg",
	"./Error_Network.svg": "./src/assets/icons/svg/Error_Network.svg",
	"./IMG-Claim.svg": "./src/assets/icons/svg/IMG-Claim.svg",
	"./IMG-No-Data.svg": "./src/assets/icons/svg/IMG-No-Data.svg",
	"./LabeledColour.svg": "./src/assets/icons/svg/LabeledColour.svg",
	"./NoMap.svg": "./src/assets/icons/svg/NoMap.svg",
	"./access_right.svg": "./src/assets/icons/svg/access_right.svg",
	"./application-cancel.svg": "./src/assets/icons/svg/application-cancel.svg",
	"./approval.svg": "./src/assets/icons/svg/approval.svg",
	"./arrow01.svg": "./src/assets/icons/svg/arrow01.svg",
	"./arrow_left_bottom.svg": "./src/assets/icons/svg/arrow_left_bottom.svg",
	"./arrow_right_top.svg": "./src/assets/icons/svg/arrow_right_top.svg",
	"./calendar_roster.svg": "./src/assets/icons/svg/calendar_roster.svg",
	"./cost_center.svg": "./src/assets/icons/svg/cost_center.svg",
	"./dragvertical.svg": "./src/assets/icons/svg/dragvertical.svg",
	"./empty.svg": "./src/assets/icons/svg/empty.svg",
	"./export.svg": "./src/assets/icons/svg/export.svg",
	"./filetype-csv.svg": "./src/assets/icons/svg/filetype-csv.svg",
	"./filetype-doc.svg": "./src/assets/icons/svg/filetype-doc.svg",
	"./filetype-file.svg": "./src/assets/icons/svg/filetype-file.svg",
	"./filetype-gif.svg": "./src/assets/icons/svg/filetype-gif.svg",
	"./filetype-image.svg": "./src/assets/icons/svg/filetype-image.svg",
	"./filetype-jpg.svg": "./src/assets/icons/svg/filetype-jpg.svg",
	"./filetype-pdf.svg": "./src/assets/icons/svg/filetype-pdf.svg",
	"./filetype-png.svg": "./src/assets/icons/svg/filetype-png.svg",
	"./filetype-ppt.svg": "./src/assets/icons/svg/filetype-ppt.svg",
	"./filetype-xls.svg": "./src/assets/icons/svg/filetype-xls.svg",
	"./flower.svg": "./src/assets/icons/svg/flower.svg",
	"./import.svg": "./src/assets/icons/svg/import.svg",
	"./left.svg": "./src/assets/icons/svg/left.svg",
	"./logoV1_ESS_full_e_blue.svg": "./src/assets/icons/svg/logoV1_ESS_full_e_blue.svg",
	"./logoV1_ESS_full_e_blue_test.svg": "./src/assets/icons/svg/logoV1_ESS_full_e_blue_test.svg",
	"./mini_doc.svg": "./src/assets/icons/svg/mini_doc.svg",
	"./news_important.svg": "./src/assets/icons/svg/news_important.svg",
	"./number.svg": "./src/assets/icons/svg/number.svg",
	"./photo.svg": "./src/assets/icons/svg/photo.svg",
	"./punch.svg": "./src/assets/icons/svg/punch.svg",
	"./right.svg": "./src/assets/icons/svg/right.svg",
	"./sendComment.svg": "./src/assets/icons/svg/sendComment.svg",
	"./service.svg": "./src/assets/icons/svg/service.svg",
	"./site.svg": "./src/assets/icons/svg/site.svg",
	"./upload.svg": "./src/assets/icons/svg/upload.svg",
	"./viewDetail.svg": "./src/assets/icons/svg/viewDetail.svg",
	"./view_leave_calender.svg": "./src/assets/icons/svg/view_leave_calender.svg",
	"./weather-dewpoint.svg": "./src/assets/icons/svg/weather-dewpoint.svg",
	"./weather-humidity.svg": "./src/assets/icons/svg/weather-humidity.svg",
	"./weather-pressure.svg": "./src/assets/icons/svg/weather-pressure.svg",
	"./weather-wind.svg": "./src/assets/icons/svg/weather-wind.svg",
	"./work.svg": "./src/assets/icons/svg/work.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync recursive \\.svg$";